export const API_GET_ALL_COMPANY = "/admin/empresas/global";
export const API_GET_ALL_PARTNERS = "/admin/empresas/empresasContadoras";
export const API_GET_SEARCH_COMPANY = "/admin/empresas/buscar/";
export const API_GET_SEARCH_ALL_COMPANY = "/admin/empresas/busquedaParametros/";
export const API_POST_SAVE_ADD_VOUCHER = "/admin/empresas";
export const API_GET_ALL_COMPANY_2 = "/admin/asignacionPaqueteEmpresa/";
export const API_POST_ADD_PARTNER = "/admin/usuarios/registro/perfil/partner";
export const API_GET_COMPANY_AUTOCOMPLETE = "/admin/empresas/contratante";
